import { action } from '@ember/object';
import Component from '@glimmer/component';
import * as THREE from 'three';
// import * as lil from 'lil-gui';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export default class PageBaseHeroComponent extends Component {
  @action
  async loadModel(canvas: HTMLCanvasElement) {
    const sizes = {
      width: 1000,
      height: 1000,
    };

    //* Scene
    const scene = new THREE.Scene();

    //*GLTFLoader
    const gltfLoader = new GLTFLoader();
    const model: THREE.Group<THREE.Object3DEventMap> = await new Promise(
      (resolve) => {
        gltfLoader.load('/assets/models/TPK/tpk_logo.glb', (gltf) => {
          gltf.scene.scale.set(0.5, 0.5, 0.5);
          scene.add(gltf.scene);
          resolve(gltf.scene);
        });
      }
    );
    model.position.set(0, 0.1, 0);

    //* Lights
    const ambientLight = new THREE.AmbientLight(0xffffff, 1);
    scene.add(ambientLight);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 3);
    directionalLight.castShadow = true;
    directionalLight.shadow.mapSize.set(1024, 1024);
    directionalLight.shadow.camera.far = 5;
    directionalLight.shadow.camera.left = -7;
    directionalLight.shadow.camera.top = 7;
    directionalLight.shadow.camera.right = 7;
    directionalLight.shadow.camera.bottom = -7;
    directionalLight.position.set(10, 5, 5);
    scene.add(directionalLight);

    //* Camera
    const camera = new THREE.PerspectiveCamera(
      50,
      sizes.width / sizes.height,
      0.1,
      100
    );
    camera.position.set(0, 0, 1);

    scene.add(camera);

    //* Controls
    const controls = new OrbitControls(camera, canvas);
    controls.target.set(0, 0, 0);
    controls.enableDamping = true;

    //* Renderer
    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
    });
    renderer.setSize(sizes.width, sizes.height);

    //* Animation
    function tick() {
      if (model) {
        model.rotation.y += 0.01;
      }

      renderer.render(scene, camera);

      window.requestAnimationFrame(tick);
    }
    tick();
  }
}
